module.exports = __webpack_public_path__ + "media/images/city/037-temple-of-the-frescoes-e683e5883ec4d183c33695b4dc830526.svg";